module.exports = new __parcel__URL__("inline-column-create-light.25926891.png").toString();